<template>
  <div>
    <div class="flex justify-end mb-4">
      <transition name="fade">
        <vs-button id="float-button" @click="goBack()">Voltar</vs-button>
      </transition>
    </div>

    <vs-card>
      <vs-row>
        <vs-col>
          <span class="font-bold text-2xl">Dados da Corretora</span>
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="flex lg:w-1/5 w-full" id="danger-text">
          <div class="w-full flex-col">
            <vs-input
              class="w-full"
              v-model="form.cpfCnpj"
              label="CPF/CNPJ"
              name="CPF/CNPJ"
              id="CPF/CNPJ"
              v-validate="{
                required: true,
                min: escolherCPFCNPJMin,
                cpfCnpj: true,
              }"
              :danger="veeErrors.has('CPF/CNPJ')"
              :danger-text="dangerText('CPF/CNPJ')"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
            />
            <span v-if="showBrokerWarning"
              >{{ brokerCpnjAlreadyExists }} existe em outra corretora"</span
            >
          </div>
          <CopyButton :value="form.cpfCnpj" />
        </vs-col>
        <vs-col class="lg:w-1/5 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.socialName"
            label="Nome/Razão Social"
            name="Nome/Razão Social"
            id="Nome/Razão Social"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Nome/Razão Social')"
            :danger-text="dangerText('Nome/Razão Social')"
          />
          <CopyButton :value="form.socialName" />
        </vs-col>
        <vs-col class="lg:w-1/5 w-full flex flex-row">
          <vs-input
            class="w-full"
            v-model="form.iss"
            label="Alíquota ISS%"
            id="Alíquota ISS%"
            name="Alíquota ISS%"
            v-validate="{
              required: true,
              min_value: 0,
              max_value: 100,
            }"
            type="number"
            :danger="veeErrors.has('Alíquota ISS%')"
            :danger-text="dangerText('Alíquota ISS%')"
            @input="formatIss"
          />

          <CopyButton :value="form.iss" />
        </vs-col>
        <vs-col class="lg:w-1/5 w-full mb-4 flex">
          <vs-input
            type="number"
            class="w-full"
            v-model="form.susepCode"
            label="Código Susep Pessoa Jurídica"
            name="Código Susep Pessoa Jurídica"
            id="Código Susep Pessoa Jurídica"
            v-validate="{
              required: true,
              min: 9,
              max: 9,
            }"
            :danger="veeErrors.has('Código Susep Pessoa Jurídica')"
            :danger-text="dangerText('Código Susep Pessoa Jurídica')"
          />
          <CopyButton :value="form.susepCode" />
        </vs-col>
        <vs-col class="lg:w-1/5 w-full flex">
          <vs-input
            type="number"
            class="w-full"
            v-model="form.municipalRegistration"
            label="Inscrição Municipal"
            id="Inscrição Municipal"
          />
          <CopyButton :value="form.municipalRegistration" />
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.partnerName"
            label="Sócio"
            id="Sócio"
            name="Sócio"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Sócio')"
            :danger-text="dangerText('Sócio')"
          />
          <CopyButton :value="form.partnerName" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.partnerCpf"
            label="CPF Sócio"
            name="CPF Sócio"
            id="CPF Sócio"
            v-validate="{
              required: true,
              min: 14,
              cpfCnpj: true,
            }"
            :danger="veeErrors.has('CPF Sócio')"
            :danger-text="dangerText('CPF Sócio')"
            v-mask="['###.###.###-##']"
          />
          <CopyButton :value="form.partnerCpf" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.partner2Name"
            label="Sócio 2"
            id="Sócio 2"
          />
          <CopyButton :value="form.partner2Name" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.partner2Cpf"
            label="CPF Sócio 2"
            name="CPF Sócio 2"
            id="CPF Sócio 2"
            v-validate="{
              required: false,
              min: 14,
              cpfCnpj: true,
            }"
            :danger="veeErrors.has('CPF Sócio 2')"
            :danger-text="dangerText('CPF Sócio 2')"
            v-mask="['###.###.###-##']"
          />
          <CopyButton :value="form.partner2Cpf" />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="lg:w-1/4 mb-4 flex">
          <div class="w-full mt-2" id="danger-text">
            <label class="vs-select--label"
              >É optante pelo Simples Nacional?</label
            >
            <v-select
              id="Optante pelo Simples Nacional"
              name="Optante pelo Simples Nacional"
              label="label"
              :options="yesNoOptions"
              class="w-full"
              v-model="form.isNationalSimple"
              :reduce="(item) => item.value"
              v-validate="{ required: true }"
              :state="
                validateState(
                  veeFields,
                  veeErrors,
                  'Optante pelo Simples Nacional',
                )
              "
              :class="
                validateStateClass(
                  veeFields,
                  veeErrors,
                  'Optante pelo Simples Nacional',
                )
              "
            >
            </v-select>
            <span v-if="veeErrors.has('Optante pelo Simples Nacional')">{{
              requiredFiledCustonMessage
            }}</span>
          </div>
          <CopyButton :value="form.isNationalSimple" />
        </vs-col>
        <vs-col class="lg:w-1/4 mb-4 flex">
          <div class="w-full mt-2" id="danger-text">
            <label class="vs-select--label"
              >Pertence a alguma Assessoria?</label
            >
            <v-select
              id="Pertence a alguma Assessoria?"
              name="Pertence a alguma Assessoria?"
              label="label"
              :options="yesNoOptions"
              class="w-full"
              v-model="form.belongsToConsultancy"
              :reduce="(item) => item.value"
              v-validate="{ required: true }"
              :state="
                validateState(
                  veeFields,
                  veeErrors,
                  'Pertence a alguma Assessoria?',
                )
              "
              :class="
                validateStateClass(
                  veeFields,
                  veeErrors,
                  'Pertence a alguma Assessoria?',
                )
              "
            ></v-select>
            <span v-if="veeErrors.has('Pertence a alguma Assessoria?')">{{
              requiredFiledCustonMessage
            }}</span>
          </div>
          <CopyButton :value="form.belongsToConsultancy" />
        </vs-col>
        <vs-col
          v-if="belongsToConsultancy"
          class="lg:w-1/4 w-full flex"
          id="danger-text"
        >
          <div class="w-full mt-2">
            <label class="vs-select--label">Nome da Assessoria</label>
            <v-select
              id="Nome da assessoria"
              name="Nome da assessoria"
              label="label"
              :options="consultancies"
              class="w-full"
              v-model="form.consultancyName"
              :reduce="(item) => item.label"
              v-validate="{ required: belongsToConsultancy }"
              :state="validateState(veeFields, veeErrors, 'Nome da assessoria')"
              :class="
                validateStateClass(veeFields, veeErrors, 'Nome da assessoria')
              "
            ></v-select>
            <span v-if="showConsultancyWarning"
              >Assessoria "{{ unknownConsultancyName }}" não encontrada</span
            >
            <span
              v-if="
                veeErrors.has('Nome da assessoria') && !showConsultancyWarning
              "
              >{{ requiredFiledCustonMessage }}</span
            >
          </div>
          <CopyButton :value="form.consultancyName" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full">
          <div class="w-full mt-2 flex flex-col">
            <label class="vs-select--label">Portal</label>
            <span class="ml-2 mt-3">{{ data.portal }}</span>
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Contato Administração</span>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.administrationContactName"
            label="Nome Completo Administração"
            name="Nome Completo Administração"
            id="Nome Completo Administração"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Nome Completo Administração')"
            :danger-text="dangerText('Nome Completo Administração')"
          />
          <CopyButton :value="form.administrationContactName" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.administrationContactCpf"
            label="CPF Administração"
            name="CPF Administração"
            id="CPF Administração"
            v-validate="{
              required: true,
              min: 14,
              cpfCnpj: true,
            }"
            :danger="veeErrors.has('CPF Administração')"
            :danger-text="dangerText('CPF Administração')"
            v-mask="['###.###.###-##']"
          />
          <CopyButton :value="form.administrationContactCpf" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.administrationContactEmail"
            label="Email Administração"
            name="Email Administração"
            id="Email Administração"
            v-validate="{
              required: true,
              email: true,
            }"
            :danger="veeErrors.has('Email Administração')"
            :danger-text="dangerText('Email Administração')"
          />
          <CopyButton :value="form.administrationContactEmail" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.administrationContactCellphone"
            label="Celular Administração"
            v-mask="['(##) #####-####']"
            name="Celular Administração"
            id="Celular Administração"
            v-validate="{
              required: true,
              min: 15,
              cellphone: true,
            }"
            :danger="veeErrors.has('Celular Administração')"
            :danger-text="dangerText('Celular Administração')"
          />
          <CopyButton :value="form.administrationContactCellphone" />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Contato Calculista</span>
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.calculatorContactName"
            label="Nome Completo Calculista"
            name="Nome Completo Calculista"
            id="Nome Completo Calculista"
            v-validate="{
              required: calculatorDataRequired(),
              min: 3,
            }"
            :danger="veeErrors.has('Nome Completo Calculista')"
            :danger-text="dangerText('Nome Completo Calculista')"
          />
          <CopyButton :value="form.calculatorContactName" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.calculatorContactCpf"
            label="CPF Calculista"
            name="CPF Calculista"
            id="CPF Calculista"
            v-validate="{
              required: calculatorDataRequired(),
              min: 14,
              cpfCnpj: true,
              calculator_cpf: true,
            }"
            :danger="veeErrors.has('CPF Calculista')"
            :danger-text="dangerText('CPF Calculista')"
            v-mask="['###.###.###-##']"
          />
          <CopyButton :value="form.calculatorContactCpf" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.calculatorContactEmail"
            label="Email Calculista"
            name="Email Calculista"
            id="Email Calculista"
            v-validate="{
              required: calculatorDataRequired(),
              email: true,
              calculator_email: true,
            }"
            :danger="veeErrors.has('Email Calculista')"
            :danger-text="dangerText('Email Calculista')"
          />
          <CopyButton :value="form.calculatorContactEmail" />
        </vs-col>
        <vs-col class="lg:w-1/4 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.calculatorContactCellphone"
            label="Celular Calculista"
            v-mask="['(##) #####-####']"
            name="Celular Calculista"
            id="Celular Calculista"
            v-validate="{
              required: calculatorDataRequired(),
              min: 15,
              cellphone: true,
            }"
            :danger="veeErrors.has('Celular Calculista')"
            :danger-text="dangerText('Celular Calculista')"
          />
          <CopyButton :value="form.calculatorContactCellphone" />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Endereço da Corretora</span>
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-4/12 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.postalCode"
            label="Cep"
            v-mask="['#####-###']"
            name="Cep"
            id="Cep"
            v-validate="{
              required: true,
              min: 9,
            }"
            :danger="veeErrors.has('Cep')"
            :danger-text="dangerText('Cep')"
          />
          <CopyButton :value="form.postalCode" />
        </vs-col>
        <vs-col class="lg:w-4/12 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.address"
            label="Endereço"
            name="Endereço"
            id="Endereço"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Endereço')"
            :danger-text="dangerText('Endereço')"
          />
          <CopyButton :value="form.address" />
        </vs-col>
        <vs-col class="lg:w-2/12 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.addressNumber"
            label="Número"
            name="Número"
            id="Número"
            v-validate="{
              required: true,
              min: 1,
              max: 10,
            }"
            :danger="veeErrors.has('Número')"
            :danger-text="dangerText('Número')"
          />
          <CopyButton :value="form.addressNumber" />
        </vs-col>
        <vs-col class="lg:w-2/12 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.addressComplement"
            label="Complemento"
            id="Complemento"
          />
          <CopyButton :value="form.addressComplement" />
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.addressNeighborhood"
            label="Bairro"
            name="Bairro"
            id="Bairro"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Bairro')"
            :danger-text="dangerText('Bairro')"
          />
          <CopyButton :value="form.addressNeighborhood" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.addressCity"
            label="Município"
            name="Município"
            id="Município"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Município')"
            :danger-text="dangerText('Município')"
          />
          <CopyButton :value="form.addressCity" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.addressState"
            label="UF"
            name="UF"
            id="UF"
            v-validate="{
              required: true,
              min: 2,
            }"
            :danger="veeErrors.has('UF')"
            :danger-text="dangerText('UF')"
          />
          <CopyButton :value="form.addressState" />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl"
            >Dados Bancários para Crédito Comissão</span
          >
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.bank"
            label="Banco"
            name="Banco"
            id="Banco"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Banco')"
            :danger-text="dangerText('Banco')"
          />
          <CopyButton :value="form.bank" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex" id="danger-text">
          <div class="w-full flex-col mt-2">
            <label class="vs-select--label">Código do Banco</label>
            <v-select
              id="Código do Banco"
              name="Código do Banco"
              label="label"
              :options="banks"
              class="w-full"
              v-model="form.bankCode"
              :reduce="(item) => item.id"
              v-validate="{ required: true }"
              :state="validateState(veeFields, veeErrors, 'Código do Banco')"
              :class="
                validateStateClass(veeFields, veeErrors, 'Código do Banco')
              "
            ></v-select>
            <span v-if="showBankCodeWarning"
              >Código "{{ unknownBankCode }}" não encontrado</span
            >
            <span
              v-if="veeErrors.has('Código do Banco') && !showBankCodeWarning"
              >{{ requiredFiledCustonMessage }}</span
            >
          </div>
          <CopyButton :value="form.bankCode" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.bankAgency"
            label="Agência"
            name="Agência"
            id="Agência"
            v-validate="{
              required: true,
              min: 3,
              max: 9,
            }"
            :danger="veeErrors.has('Agência')"
            :danger-text="dangerText('Agência')"
          />
          <CopyButton :value="form.bankAgency" />
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/2 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.bankAccount"
            label="Conta-Corrente c/ Dígito"
            name="Conta-Corrente c/ Dígito"
            id="Conta-Corrente c/ Dígito"
            v-validate="{
              required: true,
              min: 3,
              max: 14,
            }"
            :danger="veeErrors.has('Conta-Corrente c/ Dígito')"
            :danger-text="dangerText('Conta-Corrente c/ Dígito')"
          />
          <CopyButton :value="form.bankAccount" />
        </vs-col>
        <vs-col class="lg:w-1/2 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.pixKey"
            label="Chave pix"
            id="Chave pix"
          />
          <CopyButton :value="form.pixKey" />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Dados do Responsável Técnico</span>
        </vs-col>
      </vs-row>
      <vs-row class="flex flex-row">
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.technicalResponsibleName"
            label="Nome Completo Responsável Técnico"
            name="Nome Completo Responsável Técnico"
            id="Nome Completo Responsável Técnico"
            v-validate="{
              required: true,
              min: 3,
            }"
            :danger="veeErrors.has('Nome Completo Responsável Técnico')"
            :danger-text="dangerText('Nome Completo Responsável Técnico')"
          />
          <CopyButton :value="form.technicalResponsibleName" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.technicalResponsibleCpf"
            label="CPF Responsável Técnico"
            name="CPF Responsável Técnico"
            id="CPF Responsável Técnico"
            v-validate="{
              required: true,
              min: 14,
              cpfCnpj: true,
            }"
            :danger="veeErrors.has('CPF Responsável Técnico')"
            :danger-text="dangerText('CPF Responsável Técnico')"
            v-mask="['###.###.###-##']"
          />
          <CopyButton :value="form.technicalResponsibleCpf" />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4 flex">
          <vs-input
            class="w-full"
            v-model="form.technicalResponsibleSusepCode"
            label="Código SUSEP Responsável Técnico"
            name="Código SUSEP Responsável Técnico"
            id="Código SUSEP Responsável Técnico"
            v-validate="{
              required: true,
              min: 9,
              max: 9,
            }"
            :danger="veeErrors.has('Código SUSEP Responsável Técnico')"
            :danger-text="dangerText('Código SUSEP Responsável Técnico')"
          />
          <CopyButton :value="form.technicalResponsibleSusepCode" />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Produção Anual</span>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="flex gap-8 items-center">
          <div class="flex gap-8 flex-wrap mt-4">
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="Até R$20.000"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
              >Até R$20.000</vs-radio
            >
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="De R$20.001 a R$50.000"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
              >De R$20.001 a R$50.000</vs-radio
            >
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="De R$50.001 a R$80.000"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
            >
              De R$50.001 a R$80.000</vs-radio
            >
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="De R$80.001 a R$100.000"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
            >
              De R$80.001 a R$100.000</vs-radio
            >
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="De R$100.001 a R$300.000"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
              >De 100.001 a 300.000</vs-radio
            >
            <vs-radio
              v-model="form.annualProduction"
              vs-name="annual_production"
              vs-value="Acima de R$300.001"
              name="Produção Anual"
              id="Produção Anual"
              v-validate="{
                required: true,
              }"
              >Acima de R$300.001</vs-radio
            >
          </div>
          <CopyButton :value="form.annualProduction" />
        </vs-col>

        <vs-col
          id="danger-text"
          v-if="veeErrors.has('Produção Anual')"
          class="mt-2 ml-1"
          ><span>Selecione uma opção</span></vs-col
        >
      </vs-row>
      <vs-row class="mt-8 flex flex-row">
        <vs-col class="w-7/12">
          <span class="font-bold text-2xl">Documentos</span>
        </vs-col>
        <vs-col class="w-2/12">
          <div class="flex gap-4 justify-end">
            <vs-button
              v-tooltip="'Baixar todos os arquivos'"
              radius
              size="large"
              icon-pack="feather"
              icon="icon-download"
              @click="downloadFiles()"
            />
            <vs-button
              v-tooltip="'Adicionar Documento'"
              radius
              color="primary"
              size="large"
              icon-pack="feather"
              icon="icon-plus"
              class="d-inline"
              @click.prevent="chooseFiles('Upload de arquivos')"
            />
          </div>
        </vs-col>
        <vs-col class="w-3/12">
          <vs-input
            id="Upload de arquivos"
            name="Upload de arquivos"
            type="file"
            hidden
            multiple
            @change="handleFiles($event.target.files)"
          />
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col class="lg:w-9/12 w-full mb-4 flex" style="height: fit-content">
          <div class="flex flex-row flex-wrap gap-4">
            <div
              id="badge"
              v-for="(item, index) of attachmentFiles"
              :key="index"
              class="flex gap-4 items-center"
            >
              <div @click="openAttachment(item.value)">
                <span>{{ item.label }}</span>
              </div>
              <div @click="removeFile(item.value, index)">
                <vs-icon
                  class="ml-2 trash-icon"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                ></vs-icon>
              </div>
            </div>
          </div>
        </vs-col>
        <vs-col class="lg:w-3/12 w-full mb-4">
          <label class="vs-select--label text-sm"
            >Selecione a Logo da Corretora Entre os Arquivos de Imagem</label
          >
          <v-select
            id="teste"
            name="Logo da Corretora"
            label="label"
            :options="imagesAttachments"
            class="w-full"
            v-model="form.brokerLogoUrl"
            :reduce="(item) => item.value"
          >
          </v-select>
          <div class="mt-4 w-full flex justify-center">
            <img
              v-if="form.brokerLogoUrl"
              class="imagem w-64 h-48"
              :src="form.brokerLogoUrl"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Observações</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col>
          <vs-textarea
            class="w-full"
            v-model="form.observations"
            label="Observações"
          />
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col>
          <span class="font-bold text-2xl">Termos</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col class="flex flex-row gap-8">
          <vs-checkbox v-model="acceptLgpdTerms" disabled
            >Aceita os termos LGPD</vs-checkbox
          >
          <vs-checkbox v-model="acceptResponsabilityTerms" disabled
            >Aceita os termos de responsabilidade</vs-checkbox
          >
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col class="flex justify-end">
          <div
            v-if="haveReadPermission && hasNotProcessed(data.registerStatus)"
            class="flex gap-4 justify-end"
          >
            <vs-button
              v-if="!isPendingDocumentation"
              @click="update(BROKER_PRE_REGISTER_ACTIONS.PENDING_DOCUMENTATION)"
              color="warning"
              >Pendenciar documentação</vs-button
            >
            <vs-button
              @click="update(BROKER_PRE_REGISTER_ACTIONS.UPDATE)"
              color="dark"
              >Salvar</vs-button
            >
            <vs-button
              @click="update(BROKER_PRE_REGISTER_ACTIONS.REJECT)"
              color="danger"
              >Recusar Cadastro</vs-button
            >
            <vs-button
              @click="update(BROKER_PRE_REGISTER_ACTIONS.APPROVE)"
              color="success"
              :disabled="isFormInValid"
              >Aprovar Cadastro</vs-button
            >
          </div>
          <div v-else class="flex gap-4 justify-end">
            <vs-button @click="saveObservations()" color="dark"
              >Salvar Observações</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>
<script>
import brokersPreRegister from '../../../../../services/brokers-pre-register';
import notify from '../../../../../utils/notify';
import utilsList from '../../../../../utils/list';
import { Validator } from 'vee-validate';
import {
  BROKER_PRE_REGISTER_ACTIONS,
  BROKER_PRE_REGISTER_FORM_FIELDS,
  BROKER_PRE_REGISTER_STATUS,
  NO_VALUE,
  YES_AND_NO_OPTIONS,
  YES_VALUE,
} from '../constants/broker.pre.register';
import vSelect from 'vue-select';
import functions from '../../../../../utils/functions';
import CopyButton from '../../../../../components/CopyButton.vue';
import { IMAGE_FILE_EXTENSIONS } from '../../../../../constants/common.constant';
import { FORM_MESSAGES } from '../../../../../utils/constants';
import fileDownload from '../../../../../utils/fileDownload';

export default {
  name: 'BrokerPreRegisterEdit',
  components: {
    'v-select': vSelect,
    CopyButton,
  },
  props: {},
  data() {
    return {
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      yesNoOptions: YES_AND_NO_OPTIONS,
      BROKER_PRE_REGISTER_ACTIONS,
      requiredFiledCustonMessage: FORM_MESSAGES.REQUIRED_FIELD,
      consultancies: [],
      banks: [],
      data: {},
      form: {
        attachments: [],
      },
      acceptLgpdTerms: true,
      acceptResponsabilityTerms: true,
      maxSize50Mb: 50 * 1024 * 1024,
      maxSizeMessage: 'Cada arquivo deve ter no maximo 50MB.',
      showReturnButton: false,
      brokerCpnjAlreadyExists: null,
      brokerWarning: false,
      consultancyWarning: false,
      bankWarning: false,
    };
  },
  computed: {
    haveReadPermission() {
      return this.$can('Escrita', 'Pré-Cadastro Corretoras');
    },
    escolherCPFCNPJMin() {
      return this.form.cpfCnpj && this.form.cpfCnpj.length <= 14 ? 14 : 18;
    },
    belongsToConsultancy() {
      return this.form.belongsToConsultancy === YES_VALUE;
    },
    showConsultancyWarning() {
      return (
        this.belongsToConsultancy &&
        !this.form.consultancyName &&
        this.consultancyWarning
      );
    },
    showBankCodeWarning() {
      return !this.form.bankCode && this.bankWarning;
    },
    showBrokerWarning() {
      if (
        [
          BROKER_PRE_REGISTER_STATUS.APPROVED,
          BROKER_PRE_REGISTER_STATUS.REJECTED,
          BROKER_PRE_REGISTER_STATUS.EXTERNAL_REGISTRATION,
          BROKER_PRE_REGISTER_STATUS.MANUAL_REGISTRATION,
          BROKER_PRE_REGISTER_STATUS.ERROR,
        ].includes(this.data.registerStatus)
      ) {
        return false;
      }

      return this.brokerCpnjAlreadyExists && this.brokerWarning;
    },
    attachmentFiles() {
      return this.managementAttachments(this.form.attachments);
    },
    imagesAttachments() {
      return this.managementAttachments(
        this.form.attachments.filter((item) => {
          const extension = item.split('.').pop();
          return IMAGE_FILE_EXTENSIONS.includes(extension);
        }),
      );
    },
    isFormInValid() {
      return this.$validator.errors.any() || this.showBrokerWarning;
    },
    isPendingDocumentation() {
      return (
        this.data.registerStatus ===
        BROKER_PRE_REGISTER_STATUS.PENDING_DOCUMENTATION
      );
    },
  },
  watch: {
    'form.cpfCnpj': function (newValue) {
      if (newValue && newValue.length === this.escolherCPFCNPJMin) {
        this.checkBrokerExistsByCnpj(newValue);
      }
    },
    'form.belongsToConsultancy': function (newValue) {
      if (newValue === NO_VALUE && this.form.consultancyName) {
        this.form.consultancyName = null;
      }
    },
    'form.bankCode': function (newValue, oldValue) {
      if (newValue && oldValue === null) {
        this.bankWarning = false;
      }
    },
    'form.consultancyName': function (newValue, oldValue) {
      if (newValue && oldValue === null) {
        this.consultancyWarning = false;
      }
    },
  },
  created() {
    Validator.extend('calculator_cpf', {
      validate: (value) => value !== this.form.administrationContactCpf,
      getMessage: () =>
        'O CPF do calculista deve ser diferente do CPF do Contado Administração',
    });
    Validator.extend('calculator_email', {
      validate: (value) => value !== this.form.administrationContactEmail,
      getMessage: () =>
        'O Email do calculista deve ser diferente do Email do Contado Administração',
    });
  },
  async mounted() {
    window.addEventListener('scroll', this.verifyScroll);
    await this.getDominios();
    this.getPreRegisterData();
  },
  methods: {
    verifyScroll() {
      this.showReturnButton = window.scrollY > 0;
    },
    getPreRegisterData() {
      const id = this.$route.params.id;
      this.$vs.loading();
      brokersPreRegister
        .getBrokersPreRegisterById(id)
        .then((response) => {
          this.data = response;
          this.fillForm();
        })
        .then(() => this.checkConsultancyExistsInDomais())
        .then(() => this.checkbankCodeExistsInDomais())
        .then(() => this.$validator.validateAll())
        .catch((error) => {
          notify.notifyFail(this.$vs, error.message);
        })
        .finally(() => this.$vs.loading.close());
    },
    async downloadFiles() {
      try {
        this.$vs.loading();
        const id = this.$route.params.id;
        const documents = await brokersPreRegister.downloadDocuments(id);

        fileDownload.downloadManyChooseDirectoryFromBase64(window, documents);
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível baixar os arquivos');
      } finally {
        this.$vs.loading.close();
      }
    },
    fillForm() {
      const newForm = Object.fromEntries(
        BROKER_PRE_REGISTER_FORM_FIELDS.map((key) => [
          key,
          JSON.parse(JSON.stringify(this.data[key])),
        ]),
      );
      newForm.bankCode = +this.data.bankCode;
      this.form = newForm;
    },
    managementAttachments(attachments) {
      return attachments.map((attachment) => {
        return {
          label: decodeURIComponent(attachment).split('/').pop(),
          value: attachment,
        };
      });
    },
    hasNotProcessed(status) {
      const processedStatus = [
        BROKER_PRE_REGISTER_STATUS.APPROVED,
        BROKER_PRE_REGISTER_STATUS.REJECTED,
        BROKER_PRE_REGISTER_STATUS.ERROR,
        BROKER_PRE_REGISTER_STATUS.MANUAL_REGISTRATION,
        BROKER_PRE_REGISTER_STATUS.EXTERNAL_REGISTRATION,
      ];

      return !processedStatus.includes(status);
    },
    dangerText(field) {
      const errorMessage = this.veeErrors.items.find(
        (item) => item.field === field,
      );

      return errorMessage ? errorMessage.msg : '';
    },
    openAttachment(url) {
      window.open(url, '_blank');
    },
    goBack() {
      this.$router.go(-1);
    },
    formatIss(value) {
      let [integer, decimal] = String(value).split('.');

      integer = integer.slice(0, 3);

      if (decimal) {
        decimal = decimal.slice(0, 2);
        return (this.form.iss = `${integer}.${decimal}`);
      }

      this.form.iss = integer;
    },
    calculatorDataRequired() {
      return (
        Boolean(this.form.calculatorContactName) ||
        Boolean(this.form.calculatorContactCpf) ||
        Boolean(this.form.calculatorContactEmail) ||
        Boolean(this.form.calculatorContactCellphone)
      );
    },
    async getDominios() {
      try {
        await Promise.all([
          functions.buscaDadosSelects(
            'divisoes',
            this.consultancies,
            'nomeDivisao',
            'idDivisao',
          ),
          functions.buscaDadosSelects(
            'domBancos',
            this.banks,
            'LongName',
            'idBanco',
          ),
        ]);

        this.banks = this.banks
          .map((bank) => {
            const COMPE = bank.label.split(' - ')[0];
            return {
              id: +COMPE,
              label: bank.label,
              bankId: bank.id,
            };
          })
          .sort((a, b) => {
            const COMPE_A = a.label.split(' - ')[0];
            const COMPE_B = b.label.split(' - ')[0];

            return +COMPE_A - +COMPE_B;
          });
      } catch (error) {
        notify.notifyFail(this.$vs, error.message);
      }
    },
    checkBrokerExistsByCnpj() {
      brokersPreRegister
        .checkBrokerExistsByCnpj(this.form.cpfCnpj)
        .then((response) => {
          this.brokerWarning = response.exists;
          this.brokerCpnjAlreadyExists = response.exists
            ? this.form.cpfCnpj
            : null;
        });
    },
    checkConsultancyExistsInDomais() {
      if (!this.belongsToConsultancy || !this.form.consultancyName) {
        return;
      }

      let consultacy = null;

      if (this.form.consultancyName) {
        consultacy = this.consultancies.find(
          (item) =>
            item.label.toLowerCase() ===
            this.form.consultancyName.toLowerCase(),
        );
      }

      if (!consultacy) {
        this.unknownConsultancyName = this.form.consultancyName;
        this.form.consultancyName = null;
        this.consultancyWarning = true;
      }
    },
    checkbankCodeExistsInDomais() {
      if (
        this.form.bankCode === null ||
        this.form.bankCode === undefined ||
        this.form.bankCode === ''
      ) {
        return;
      }

      const bank = this.banks.find((item) => +item.id === +this.form.bankCode);

      if (!bank) {
        this.unknownBankCode = this.form.bankCode;
        this.form.bankCode = null;
        this.bankWarning = true;
      }
    },
    copyToClipboard(elementId) {
      const input = document.getElementById(elementId);
      input.select();
      navigator.clipboard
        .writeText(input.value)
        .then(() => {
          notify.notifySuccess(
            this.$vs,
            'Copiado para a área de transferência.',
          );
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao copiar');
        });
    },
    async handleFiles(files) {
      const filesArray = Array.from(files);

      const validatedFiles = filesArray.map((file) =>
        this.validatedFileSize(file),
      );

      this.$vs.loading();
      await Promise.all(validatedFiles.map((file) => this.uploadAWS(file)));
      this.$vs.loading.close();
    },
    validatedFileSize(file) {
      const size = file.size;

      if (size > this.maxSize50Mb) {
        notify.notifyFail(this.$vs, this.maxSizeMessage);
        return;
      }

      const sanitizedFileName = functions.sanitizeString(file.name);
      const sanitizedFile = new File([file], sanitizedFileName, {
        type: file.type,
      });

      return sanitizedFile;
    },
    async uploadAWS(file) {
      const formDataSend = new FormData();
      const filePathName = '1971847a12da99f9';
      formDataSend.append('file', file, file.name);
      formDataSend.append('path', filePathName);

      try {
        const res = await brokersPreRegister.upload(formDataSend);
        this.form.attachments.push(res);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    chooseFiles(inputId) {
      document.getElementById(inputId).click();
    },
    removeFile(file, index) {
      this.form.attachments.splice(index, 1);
      if (file === this.form.brokerLogoUrl) {
        this.form.brokerLogoUrl = null;
      }
    },
    async validateForm() {
      const formValidation = await this.$validator.validateAll();

      if (!formValidation) {
        notify.notifyFail(this.$vs, 'Preencha todos os campos obrigatórios');
        return false;
      }

      return true;
    },
    async saveObservations() {
      try {
        this.$vs.loading();

        await brokersPreRegister.saveObservations(this.form.id, {
          observations: this.form.observations,
        });

        this.$vs.notify({
          title: 'Sucesso',
          text: 'Observações salvas com sucesso!',
          color: 'success',
          position: 'top-center',
          time: 2000,
        });
      } catch (errorMessage) {
        this.$vs.notify({
          title: 'Erro',
          text: errorMessage ? errorMessage : 'Erro: tente novamente!',
          color: 'danger',
          position: 'top-center',
          time: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async update(action = undefined) {
      try {
        const isApprovedAction = action === BROKER_PRE_REGISTER_ACTIONS.APPROVE;

        if (isApprovedAction) {
          const validateForm = await this.validateForm();

          if (!validateForm) {
            return;
          }
        }

        let consultacy = null;

        if (this.form.consultancyName) {
          consultacy = this.consultancies.find(
            (item) =>
              item.label.toLowerCase() ===
              this.form.consultancyName.toLowerCase(),
          );
        }
        const consultancyId = consultacy ? consultacy.id : null;

        const bank = this.banks.find((item) => item.id === this.form.bankCode);
        const bankId = bank ? bank.bankId : null;

        const payload = { ...this.form, consultancyId, bankId, action };

        this.$vs.loading();

        await brokersPreRegister.update(this.form.id, payload);

        this.$vs.notify({
          title: 'Sucesso',
          text: action
            ? 'Cadastro processado com sucesso!'
            : 'Pré-cadastro da corretora salvo com sucesso!',
          color: 'success',
          position: 'top-center',
          time: action ? 5000 : 2000,
        });

        this.$emit('search');
        if (action !== BROKER_PRE_REGISTER_ACTIONS.UPDATE) {
          this.goBack();
        }
      } catch (errorMessage) {
        this.$vs.notify({
          title: 'Erro',
          text: errorMessage ? errorMessage : 'Erro: tente novamente!',
          color: 'danger',
          position: 'top-center',
          time: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.verifyScroll);
    },
  },
};
</script>
<style lang="scss" scoped>
#danger-text {
  span {
    color: #ea5455;
  }
}
#badge {
  height: fit-content;
  background-color: #f2f2f2;
  padding: 2px 0px 2px 10px;
  border-radius: 20px;
  cursor: pointer;
}
</style>
<style>
.v-select .vs__selected {
  word-break: break-word;
  overflow-wrap: break-word;
}

#float-button {
  position: fixed;
  bottom: 5%;
  right: 5.8%;
  z-index: 1000;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
